import React, { useEffect, useState } from 'react';
import { Button, Space, Table, message } from 'antd';
import { Adminauthcontexthooks } from '../../Hooks/Adminauthcontexthooks';


const Externallinkstable = () => {
    const columns = [
        {
            title: 'Link Name',
            dataIndex: 'Extlinkname',
            key: 'Extlinkname',
        },
        {
            title: 'Ext. Link',
            dataIndex: 'Extlink',
            key: 'Extlink',
            render: text => (
                <a
                    href={text}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Ext. Link
                </a>
            ),
        },
        {
            title: 'Action',
            key: 'action',
            render: (id, record) => (
                <Space size="middle">
                    <Button color="red" variant="dashed" onClick={() => Delextlink(id)} loading={subbtnloading} disabled={subbtnloading}>Delete</Button>
                </Space>
            ),
        },
    ];
    const { user } = Adminauthcontexthooks();
    const [data, setdata] = useState([]);
    const [loading, setloading] = useState(true);
    const [subbtnloading, setsubbtnloading] = useState(false);

    const GetExtLinks = async () => {
        const res = await fetch('https://cdr-backend.onrender.com/get/external-links', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`
            }

        });
        const data = await res.json();
        if (res.status === 200) {
            setdata(data.ExtlinksOBJ);
            setloading(false);
        }
    }
    const Delextlink = async (obj) => {
        const id = obj._id
        const res = await fetch(`https://cdr-backend.onrender.com/delete/ext-link/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`
            }
        });
        if (res.status === 200) {
            message.success("Link deleted successfully");
            setsubbtnloading(false);
            GetExtLinks();
            return;
        } else {
            message.error("Something went wrong");
            setsubbtnloading(false);
            return;
        }
    }

    useEffect(() => {
        if (user) {
            const GetExtLinks = async () => {
                const res = await fetch('https://cdr-backend.onrender.com/get/external-links', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${user}`
                    }

                });
                const data = await res.json();
                if (res.status === 200) {
                    setdata(data.ExtlinksOBJ);
                    setloading(false);
                }
            }
            GetExtLinks()
        }

    }, [data, user])
    return (
        <>
            <Table columns={columns} dataSource={data} loading={loading} />
        </>
    )
}

export default Externallinkstable;